import React from 'react'
import { IconClose } from 'components/Zui/Icon'
import './index.css'

function index({ headerText, onClose, children, buttonText = 'Close' }) {
    return (
        <div className="details-popup-wrap">
            <div className="details-popup-header">
                <div className="title-wrap">
                    <span>{headerText}</span>
                </div>
                <div className="close-popup-wrap" onClick={onClose}>
                    <IconClose />
                </div>
            </div>
            {children}
            <div className="details-popup-footer">
                <div className="close-button" onClick={onClose}>
                    {buttonText}
                </div>
            </div>
        </div>
    )
}

export default index
